import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { TextInput } from 'is24-corecss'

import { LinkState } from './MultimediaLinksManager'

export interface MultimediaLinksManagerProps extends LinkState {
  onChange: (property: string, value: string) => void
  onBlur: (property: string, value: string) => void
}

const MultimediaAddLink: React.FC<MultimediaLinksManagerProps> = ({
  isValidLinkAddress,
  isValidLinkTitle,
  linkAddress,
  linkTitle,
  onChange,
  onBlur,
}) => {
  const { t } = useTranslation()

  const doChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>, property: string) =>
    onChange(property, value)
  const doBlur = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>, property: string) =>
    onBlur(property, value)

  return (
    <>
      <div className='one-whole margin-top-l'>
        <TextInput.Root id='link-address' invalid={!isValidLinkAddress}>
          <TextInput.Label>
            {t('wizard.screen.multimedia.linksManager.linkAddressLabel', 'Link (Internet address)')}
          </TextInput.Label>
          <TextInput.Input
            type='text'
            value={linkAddress}
            placeholder={t(
              'wizard.screen.multimedia.linksManager.linkAddressPlaceholder',
              'e.g. www.my-web-address.com'
            )}
            onChange={(value: ChangeEvent<HTMLInputElement>) => doChange(value, 'linkAddress')}
            onBlur={(value: ChangeEvent<HTMLInputElement>) => doBlur(value, 'linkAddress')}
          />
          <TextInput.ErrorText>
            {t('validation.multimediaLinkValidationError', 'Invalid or missing characters')}
          </TextInput.ErrorText>
        </TextInput.Root>
      </div>
      <div className='one-whole margin-top-l'>
        <TextInput.Root id='link-title' invalid={!isValidLinkTitle}>
          <TextInput.Label>{t('wizard.screen.multimedia.linksManager.linkTitleLabel', 'Title')}</TextInput.Label>
          <TextInput.Input
            type='text'
            value={linkTitle}
            placeholder={t('wizard.screen.multimedia.linksManager.linkTitlePlaceholder', 'e.g. Homepage')}
            onChange={(value: ChangeEvent<HTMLInputElement>) => doChange(value, 'linkTitle')}
            onBlur={(value: ChangeEvent<HTMLInputElement>) => doBlur(value, 'linkTitle')}
          />
          <TextInput.ErrorText>
            {isValidLinkTitle
              ? undefined
              : t('validation.multimediaLinkValidationError', 'Invalid or missing characters')}
          </TextInput.ErrorText>
        </TextInput.Root>
      </div>
    </>
  )
}

export default MultimediaAddLink
